const configInfo = {
  state: {
    configInfo: []
  },
  mutations: {
    CONFIGINFO (state, info) {
      if (info) {
        state.configInfo = info
      } else {
        state.configInfo = null
      }
    }
  },
  getters: {
    configInfo: state => state.configInfo
  }
}

export default configInfo
